var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    width: "1em",
    height: "1em",
    style: {
      verticalAlign: "-.125em",
      msTransform: "rotate(360deg)",
      WebkitTransform: "rotate(360deg)",
      transform: "rotate(360deg)"
    },
    viewBox: "0 0 24 24",
    className: "close_svg__iconify close_svg__icon:uil:multiply close_svg__w-5 close_svg__h-5",
    "data-icon": "uil:multiply"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.41 12 6.3-6.29a1 1 0 1 0-1.42-1.42L12 10.59l-6.29-6.3a1 1 0 0 0-1.42 1.42l6.3 6.29-6.3 6.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l6.29-6.3 6.29 6.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Z"
  })));
};

export { SvgClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIKICBhcmlhLWhpZGRlbj0idHJ1ZSIKICBmb2N1c2FibGU9ImZhbHNlIgogIHdpZHRoPSIxZW0iCiAgaGVpZ2h0PSIxZW0iCiAgc3R5bGU9InZlcnRpY2FsLWFsaWduOiAtMC4xMjVlbTstbXMtdHJhbnNmb3JtOiByb3RhdGUoMzYwZGVnKTsgLXdlYmtpdC10cmFuc2Zvcm06IHJvdGF0ZSgzNjBkZWcpOyB0cmFuc2Zvcm06IHJvdGF0ZSgzNjBkZWcpOyIKICBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCBtZWV0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBkYXRhLXYtYTc2Njg3OTI9IiIKICBjbGFzcz0iaWNvbmlmeSBpY29uOnVpbDptdWx0aXBseSB3LTUgaC01IgogIGRhdGEtaWNvbj0idWlsOm11bHRpcGx5Igo+PHBhdGgKICAgIGZpbGw9ImN1cnJlbnRDb2xvciIKICAgIGQ9Im0xMy40MSAxMmw2LjMtNi4yOWExIDEgMCAxIDAtMS40Mi0xLjQyTDEyIDEwLjU5bC02LjI5LTYuM2ExIDEgMCAwIDAtMS40MiAxLjQybDYuMyA2LjI5bC02LjMgNi4yOWExIDEgMCAwIDAgMCAxLjQyYTEgMSAwIDAgMCAxLjQyIDBsNi4yOS02LjNsNi4yOSA2LjNhMSAxIDAgMCAwIDEuNDIgMGExIDEgMCAwIDAgMC0xLjQyWiIKICAvPjwvc3ZnPgo=";